import { useSite } from "../context/SiteContext";

export default function Marquee() {
    const { content, cf } = useSite();
    const words = (cf("tagline") || "Cosmetología · Barbería · Estética · Spa")
        .split("·")
        .map((w) => w.trim())
        .filter(Boolean);

    const Row = ({ hidden }) => (
        <div className="flex items-center shrink-0" aria-hidden={hidden || undefined}>
            {words.map((w, i) => (
                <span key={`${w}-${i}`} className="flex items-center shrink-0">
                    <span className="font-serif italic text-2xl sm:text-3xl text-gold/50 px-8 whitespace-nowrap">{w}</span>
                    <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold/50 shrink-0" aria-hidden="true" />
                </span>
            ))}
        </div>
    );

    return (
        <div data-testid="editorial-marquee" className="relative border-y border-gold/15 bg-[#0D0D0F] py-6 overflow-hidden">
            <div className="flex w-max animate-marquee">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
